<template lang="pug">
ReportBaseSelectFilter.work-break-status-filter(
  label="Status"
  placeholder="All statuses"
  :options="workBreakStatuses"
  query-property="work_break_statuses"
)
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportWorkBreakStatusFilter',
  computed: {
    ...mapGetters(['workBreakStatuses']),
  },
};
</script>
